import { ChevronRightIcon } from '@heroicons/react/24/outline'
import dayjs from 'dayjs'
import { isEmpty, some } from 'lodash'
import Link from 'next/link'
import { useMemo } from 'react'

import { NewIcon } from '@/shared/layout/WithCurriculumLayout/Icons'
import { checkRegister24HoursAgo } from '@/shared/utils/checkRegister24HoursAgo'

import { INotice } from '../../note/types'

interface ICurriculumKlassCardProps {
  curriculumId: string
  data: INotice[] | undefined
} 

const CurriculumNoticeCard = ({ curriculumId, data }: ICurriculumKlassCardProps) => {
  const isNew = useMemo(() => {
    if (data) {
      return some(data, notice => checkRegister24HoursAgo(notice.createdAt))
    }
  }, [data])

  return (
    <>
      {isEmpty(data) ? (
        <div className="flex h-fit w-full flex-col items-center gap-4 rounded-2xl border bg-white px-5 py-6 lg:gap-5 lg:px-7 lg:py-8">
          <div className="flex w-full flex-row items-center justify-between">
            <h5 className="flex flex-row items-center gap-1 text-lg font-semibold text-label-normal md:font-bold lg:text-xl">
              공지사항
            </h5>
            <Link
              href={`/${curriculumId}/notice`}
              className="flex flex-row items-center gap-1 text-sm text-label-neutral"
            >
              자세히보기
              <ChevronRightIcon className="w-4 shrink-0 stroke-[1.34px]" />
            </Link>
          </div>
          <ul className="flex w-full flex-col">
            <li className="w-full rounded-lg bg-alternative py-4 text-center text-sm text-label-alternative">
              작성된 공지사항이 없어요.
            </li>
          </ul>
        </div>
      ) : (
        <div className="flex h-fit w-full flex-col items-center gap-4 rounded-2xl border bg-white px-5 py-6 lg:gap-5 lg:px-7 lg:py-8">
          <div className="flex w-full flex-row items-center justify-between">
            <h5 className="flex flex-row items-center gap-1 text-lg font-semibold text-label-normal md:font-bold lg:text-xl">
              공지사항
              {isNew && <NewIcon />}
            </h5>
            <Link
              href={`/${curriculumId}/notice`}
              className="flex flex-row items-center gap-1 text-sm text-label-neutral"
            >
              자세히보기
              <ChevronRightIcon className="w-4 shrink-0 stroke-[1.34px]" />
            </Link>
          </div>
          <ul className="flex w-full flex-col">
            {data?.map(({ id, title, createdAt, views }, idx) => (
              <li
                key={idx}
                className="flex cursor-pointer flex-col gap-[4.5px] border-b border-dotted py-4 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0"
              >
                <Link href={`/${curriculumId}/notice/${id}`}>
                  <h6 className="line-clamp-1 text-base font-medium text-label-normal">{title}</h6>
                  <div className="flex flex-row items-center gap-2 text-sm text-label-alternative">
                    <span>{dayjs(createdAt).format('YY.MM.DD')}</span>
                    <span>조회수 {views?.toLocaleString()}</span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}

export default CurriculumNoticeCard
